"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBOmnibarVertical = void 0;
var user_settings_1 = require("../user-settings/user-settings");
var dom_utility_1 = require("../shared/dom-utility");
var interop_1 = require("../shared/interop");
var navigator_1 = require("../shared/navigator");
var CLS_EXPANDED = 'sky-omnibar-vertical-expanded';
var CLS_LOADING = 'sky-omnibar-vertical-loading';
var CLS_BODY = 'sky-omnibar-vertical-body';
var CLS_BODY_MINIMIZED = 'sky-omnibar-vertical-body-minimized';
var CLS_IFRAME_WRAPPER = 'sky-omnibar-vertical-iframe-wrapper';
var OMNBAR_VERTICAL_WIDTH_MAXIMIZED = 250;
var OMINIBAR_VERTICAL_WIDTH_MINIMIZED = 60;
var settingsUpdatesToIgnore = new Set();
var currentSettings;
var currentUrl;
var currentCategory;
var iframeEl;
var iframeWrapperEl;
var omnibarConfig;
var promiseResolve;
var styleEl;
var windowMediaQuery;
function updateSize() {
    if (omnibarConfig.onResize) {
        var size = 0;
        var iFrameEl = document.querySelector(".".concat(CLS_IFRAME_WRAPPER));
        if (iFrameEl) {
            var wrapperStyle = getComputedStyle(iFrameEl);
            if (wrapperStyle.display !== 'none') {
                size = document.body.classList.contains(CLS_BODY_MINIMIZED)
                    ? OMINIBAR_VERTICAL_WIDTH_MINIMIZED
                    : OMNBAR_VERTICAL_WIDTH_MAXIMIZED;
            }
        }
        omnibarConfig.onResize({
            position: 'left',
            size: size,
        });
    }
}
function userSettingsMinimized() {
    var _a;
    return (_a = currentSettings === null || currentSettings === void 0 ? void 0 : currentSettings.omnibar) === null || _a === void 0 ? void 0 : _a.vMin;
}
function expandIframe() {
    iframeWrapperEl.classList.add(CLS_EXPANDED);
}
function collapseIframe() {
    iframeWrapperEl.classList.remove(CLS_EXPANDED);
}
function addIframeEl(afterEl) {
    if (userSettingsMinimized()) {
        minimize();
    }
    var omnibarVerticalUrl = omnibarConfig.verticalUrl ||
        /* istanbul ignore next */
        'https://host.nxt.blackbaud.com/omnibar/vertical';
    iframeEl = dom_utility_1.BBAuthDomUtility.createIframe(omnibarVerticalUrl, "sky-omnibar-vertical-iframe", 'Vertical Navigation');
    iframeWrapperEl = document.createElement('div');
    iframeWrapperEl.className = "".concat(CLS_IFRAME_WRAPPER, " ").concat(CLS_LOADING);
    iframeWrapperEl.appendChild(iframeEl);
    afterEl.insertAdjacentElement('afterend', iframeWrapperEl);
    document.body.classList.add(CLS_BODY);
}
function addStyleEl(nonce) {
    var css = "\n.".concat(CLS_IFRAME_WRAPPER, " {\n  position: fixed;\n  top: 50px;\n  left: 0;\n  bottom: 0;\n  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);\n  width: ").concat(OMNBAR_VERTICAL_WIDTH_MAXIMIZED, "px;\n  z-index: 999;\n}\n\n.").concat(CLS_IFRAME_WRAPPER, ".").concat(CLS_LOADING, " {\n  border-right: solid 1px #e2e3e4;\n}\n\n.").concat(CLS_BODY_MINIMIZED, " .").concat(CLS_IFRAME_WRAPPER, ":not(.").concat(CLS_EXPANDED, ") {\n  width: ").concat(OMINIBAR_VERTICAL_WIDTH_MINIMIZED, "px;\n}\n\n.sky-omnibar-vertical-iframe {\n  border: none;\n  height: 100%;\n  width: 100%;\n}\n\n.").concat(CLS_LOADING, " .sky-omnibar-vertical-iframe {\n  visibility: hidden;\n}\n\n.").concat(CLS_EXPANDED, " {\n  width: 100%;\n}\n\n@media (min-width: 768px) {\n  .").concat(CLS_BODY, " {\n    margin-left: ").concat(OMNBAR_VERTICAL_WIDTH_MAXIMIZED, "px;\n  }\n\n  .").concat(CLS_BODY_MINIMIZED, " {\n    margin-left: ").concat(OMINIBAR_VERTICAL_WIDTH_MINIMIZED, "px;\n  }\n}\n\n@media (max-width: 767px) {\n  .").concat(CLS_IFRAME_WRAPPER, " {\n    display: none;\n  }\n}\n");
    styleEl = dom_utility_1.BBAuthDomUtility.addCss(css, nonce);
}
function windowMediaQueryChange() {
    updateSize();
}
function addWindowMediaListener() {
    if (omnibarConfig.onResize) {
        windowMediaQuery = window.matchMedia('max-width: 767px');
        windowMediaQuery.addEventListener('change', windowMediaQueryChange);
    }
}
function removeWindowMediaListener() {
    if (windowMediaQuery) {
        windowMediaQuery.removeEventListener('change', windowMediaQueryChange);
        windowMediaQuery = undefined;
    }
}
function postLocationChangeMessage() {
    interop_1.BBAuthInterop.postLocationChangeMessage(iframeEl, currentUrl, currentCategory);
}
function minimize() {
    document.body.classList.add(CLS_BODY_MINIMIZED);
    updateSize();
}
function maximize() {
    document.body.classList.remove(CLS_BODY_MINIMIZED);
}
function updateMinimized(verticalNavMinimized, updateSettings) {
    if (updateSettings) {
        var correlationId = Date.now().toString();
        // Ignore the custom message from the notifications service indicating this change has
        // taken place.
        settingsUpdatesToIgnore.add(correlationId);
        user_settings_1.BBUserSettings.updateSettings(correlationId, {
            omnibar: {
                vMin: verticalNavMinimized,
            },
        });
    }
    if (verticalNavMinimized) {
        minimize();
    }
    else {
        maximize();
    }
    updateSize();
}
function messageHandler(event) {
    var message = event.data;
    if (!interop_1.BBAuthInterop.messageIsFromOmnibarVertical(event)) {
        return;
    }
    var nav = omnibarConfig.nav;
    switch (message.messageType) {
        case 'ready':
            // Notify the omnibar of the host page's origin.  This MUST be the first
            // message that is posted to the omnibar because all other messages will
            // be validated against the provided origin.  If the origin of the host page
            // does not match a whilelist of allowed origins maintained by the omnibar,
            // further communications between the omnibar and host will be blocked.
            interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
                messageType: 'host-ready',
            });
            interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
                envId: omnibarConfig.envId,
                leId: omnibarConfig.leId,
                messageType: 'nav-ready',
                minimized: userSettingsMinimized(),
                navVersion: omnibarConfig.navVersion,
                services: nav && nav.services,
                svcId: omnibarConfig.svcId,
                theme: omnibarConfig.theme,
                widthMinimized: OMINIBAR_VERTICAL_WIDTH_MINIMIZED,
                widthMaximized: OMNBAR_VERTICAL_WIDTH_MAXIMIZED,
            });
            postLocationChangeMessage();
            promiseResolve();
            break;
        case 'display-ready':
            iframeWrapperEl.classList.remove(CLS_LOADING);
            break;
        case 'expand':
            expandIframe();
            break;
        case 'collapse':
            collapseIframe();
            break;
        case 'navigate-url':
            navigator_1.BBAuthNavigator.navigate(message.url);
            break;
        case 'navigate':
            interop_1.BBAuthInterop.handleNavigate(omnibarConfig.nav, message.navItem);
            break;
        case 'get-token':
            interop_1.BBAuthInterop.handleGetToken(iframeEl, message.tokenRequestId, message.disableRedirect);
            break;
        case 'maximize':
            updateMinimized(false, true);
            break;
        case 'minimize':
            updateMinimized(true, true);
            break;
    }
}
var BBOmnibarVertical = /** @class */ (function () {
    function BBOmnibarVertical() {
    }
    BBOmnibarVertical.load = function (config, afterEl) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                omnibarConfig = config;
                return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                        var err_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    promiseResolve = resolve;
                                    addStyleEl(config.nonce);
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, user_settings_1.BBUserSettings.getSettings()];
                                case 2:
                                    currentSettings = _a.sent();
                                    return [3 /*break*/, 4];
                                case 3:
                                    err_1 = _a.sent();
                                    return [3 /*break*/, 4];
                                case 4:
                                    addWindowMediaListener();
                                    addIframeEl(afterEl);
                                    updateSize();
                                    window.addEventListener('message', messageHandler);
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    BBOmnibarVertical.updateUrl = function (url, category) {
        currentUrl = url;
        currentCategory = category;
        postLocationChangeMessage();
    };
    BBOmnibarVertical.refreshUser = function (token) {
        interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
            messageType: 'refresh-user',
            token: token,
        });
    };
    BBOmnibarVertical.refreshSettings = function (correlationId) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!settingsUpdatesToIgnore.has(correlationId)) return [3 /*break*/, 1];
                        settingsUpdatesToIgnore.delete(correlationId);
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, user_settings_1.BBUserSettings.getSettings()];
                    case 2:
                        currentSettings = _c.sent();
                        updateMinimized((_a = currentSettings === null || currentSettings === void 0 ? void 0 : currentSettings.omnibar) === null || _a === void 0 ? void 0 : _a.vMin, false);
                        interop_1.BBAuthInterop.postOmnibarMessage(iframeEl, {
                            messageType: 'update-vertical',
                            updateArgs: {
                                minimized: (_b = currentSettings === null || currentSettings === void 0 ? void 0 : currentSettings.omnibar) === null || _b === void 0 ? void 0 : _b.vMin,
                            },
                        });
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BBOmnibarVertical.destroy = function () {
        dom_utility_1.BBAuthDomUtility.removeEl(iframeWrapperEl);
        dom_utility_1.BBAuthDomUtility.removeCss(styleEl);
        document.body.classList.remove(CLS_BODY);
        maximize();
        window.removeEventListener('message', messageHandler);
        removeWindowMediaListener();
        settingsUpdatesToIgnore.clear();
        currentSettings =
            currentUrl =
                iframeEl =
                    iframeWrapperEl =
                        omnibarConfig =
                            promiseResolve =
                                styleEl =
                                    undefined;
    };
    return BBOmnibarVertical;
}());
exports.BBOmnibarVertical = BBOmnibarVertical;
